import { RichTextBlock } from 'prismic-reactjs';
import gql from 'graphql-tag';
import { IBaseSlice, SliceTypes } from '.';
import { parseRichText, parseString } from '../utils/parsers';

export interface IFaq extends IBaseSlice {
  title: string;
  items: Array<{
    question: RichTextBlock[];
    answer: RichTextBlock[];
  }>;
}

export const fragment = (name: string, type: string, fragmentName: string) => gql`
  fragment ${fragmentName || name} on ${type} {
    ... on ${type}${name} {
      type
      primary {
        slice_title
      }
      fields {
        item_question
        item_answer
      }
    }
  }
`;

type Props = {
  primary: {
    slice_title: RichTextBlock[];
  };
  fields: Array<{
    item_question: RichTextBlock[];
    item_answer: RichTextBlock[];
  }>;
};

export const parse = (slice: Props, redirects): IFaq => ({
  type: SliceTypes.Faq,
  title: parseString(slice.primary.slice_title),
  items: slice.fields.map((field) => ({
    question: parseRichText(field.item_question, redirects),
    answer: parseRichText(field.item_answer, redirects),
  })),
});
